// libraries
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {bindActionCreators} from 'redux';

// auth
import Login from '../components';
import {onSubmit, googleLogin} from '../actions/login';

// shared
import {
  setNavigationAnnouncement
} from 'shared/actions/accessibility-announcement';

// redux form validations
const validate = (values) => {
  const errors = {};

  if (!values.identifier) {
    errors.identifier = 'Email or phone number is required';
  }

  if (!values.password) {
    errors.password = 'Password is required';
  }

  return errors;
};

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    onSubmit,
    googleLogin,
    setNavigationAnnouncement
  }, dispatch)
);

const form = reduxForm({
  form: 'login',
  fields: [
    'identifier',
    'password'
  ],
  validate
})(Login);

export default connect(
  null,
  mapDispatchToProps
)(form);
